@let hasQualificationCreatePermission =
  can(RoleAction.Create, RolePermissionSubject.UserQualificationV2);
<button
  nz-button
  nzType="primary"
  (click)="showBulkCreateDrawer()"
  [disabled]="!hasQualificationCreatePermission"
  nz-tooltip
  [nzTooltipTitle]="'general.no_permissions' | translate"
  [nzTooltipTrigger]="!hasQualificationCreatePermission ? 'hover' : null"
>
  {{ 'general.add' | translate }}
</button>
